import { cls } from "../domain/context.js";
import { esc } from "./fmt.js";

// ---------- Avatarlar ----------
// Kayıtta photo alanı varsa (Firebase Storage yolu) fotoğraf gösterilir.
// Yoksa kimliğe göre değişmeyen bir çizim üretilir — gerçek kişi görseli kullanılmaz.
export const SKIN = ["#F6D2B4", "#EDBE97", "#D9A176", "#B57A50", "#8D5A34"];
export const HAIR = ["#2B2440", "#4A3728", "#6B4423", "#A9663B", "#D9A441", "#5A5470"];

export function seedHash(str) {
  let h = 2166136261;
  for (let i = 0; i < str.length; i++) { h ^= str.charCodeAt(i); h = Math.imul(h, 16777619); }
  return h >>> 0;
}

export function faceSVG(seed, ring) {
  const h = seedHash(seed);
  const skin = SKIN[h % SKIN.length];
  const hair = HAIR[(h >>> 4) % HAIR.length];
  const cap = `<path d="M7.3 20a13 13 0 0 1 25.4 0z" fill="${hair}"/>`;
  const styles = [
    cap,
    `${cap}<circle cx="20" cy="7.5" r="4" fill="${hair}"/>`,
    `<rect x="6" y="19" width="4.6" height="14" rx="2.3" fill="${hair}"/><rect x="29.4" y="19" width="4.6" height="14" rx="2.3" fill="${hair}"/>${cap}`,
    `<circle cx="13.5" cy="14" r="5.2" fill="${hair}"/><circle cx="20" cy="11.5" r="5.6" fill="${hair}"/><circle cx="26.5" cy="14" r="5.2" fill="${hair}"/>`,
  ];
  return `<svg viewBox="0 0 40 40" class="w-full h-full" aria-hidden="true">
    <circle cx="20" cy="20" r="20" fill="${ring}22"/>
    <circle cx="20" cy="23" r="13" fill="${skin}"/>
    ${styles[(h >>> 8) % styles.length]}
    <circle cx="15.8" cy="24" r="1.5" fill="#2B2440"/>
    <circle cx="24.2" cy="24" r="1.5" fill="#2B2440"/>
    <path d="M16.2 29.2q3.8 3.2 7.6 0" fill="none" stroke="#2B2440" stroke-width="1.5" stroke-linecap="round"/>
    <circle cx="20" cy="20" r="19" fill="none" stroke="${ring}" stroke-width="2"/>
  </svg>`;
}

export function avatarMarkup(person, ring, size) {
  const inner = person.photo
    ? `<img src="${esc(person.photo)}" alt="" class="w-full h-full object-cover">`
    : faceSVG(person.id + person.name, ring);
  return `<span class="${size} rounded-full overflow-hidden shrink-0 block" title="${esc(person.name)}">${inner}</span>`;
}

export const avatar = (student, size = "w-9 h-9") => avatarMarkup(student, cls(student.classId).color, size);
export const staffAvatar = (person, size = "w-9 h-9") => avatarMarkup(person, "#8E7CC3", size);
